module.exports = __webpack_public_path__ + "img/bottom-blur.d4e1c19a.png";